export default (theme) => ({
  backButton: {
    cursor: 'pointer',
    textTransform: 'uppercase',
  },
  detailsRoot: {
    padding: 0,
  },
});
